import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Equipement } from '../../models/equipement';
import { EquipementService } from '../../services/equipement.service';
import { LogementService } from '../../services/logement.service';
import { EquipementMetadata } from "../../models/equipementMetadata";
import { CarnetEquipement } from "../../models/carnetEquipement";
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { ExtraRouterService } from "../../services/extra-router.service";
import { combineLatest, Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { Logement } from "../../models/logement";
import { DocumentService } from "../../services/document.service";

@Component({
    selector: 'app-equipement',
    templateUrl: './equipement-page.component.html',
    styleUrls: ['./equipement-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquipementPageComponent implements OnInit {

  faPen = faPen;

  logement$: Observable<Logement> = null;
  carnetEquipement$: Promise<CarnetEquipement>;
  metadata$: Promise<EquipementMetadata>;
  equipe$: Observable<boolean>;
  private carnetEquipements$: Promise<CarnetEquipement[]>;

  constructor(
    private route: ActivatedRoute,
    private logementService: LogementService,
    public equipementService: EquipementService,
    public extraRouter: ExtraRouterService,
    public documentService: DocumentService
  ) {
  }

  ngOnInit() {
    const equipementId = parseInt(this.route.snapshot.paramMap.get('id'));
    const logementId = this.logementService.getLogementCourantId();
    this.logement$ = this.logementService.logementCourant;
    this.carnetEquipement$ = this.equipementService.findDetailsById(logementId, equipementId);
    this.carnetEquipements$ = this.equipementService.load(logementId);
    this.metadata$ = this.equipementService.getMetadata(logementId, equipementId);
    this.equipe$ = combineLatest(this.carnetEquipement$, this.carnetEquipements$).pipe(map(([carnetEquipement, carnetEquipements]) => {
      return carnetEquipements.find(ce => ce.equipement.id == carnetEquipement.equipement.id && this.equipementService.isAuthorizedToEdit(ce))  != null;
    }));
  }


}
